import { useSelector } from "react-redux"
import { IGeneral } from "../../../store/General"
import { StatusBadge } from "./StatusBadge"

type Props = { code: string | null | undefined }

export function PaymentStatusBadge({ code }: Props) {
  const paymentStatus = useSelector((s: { general: IGeneral }) => s.general.paymentStatus)
  return <StatusBadge code={code} catalog={paymentStatus} />
}
